import { css } from '@emotion/react'

import Colour from '@thebeansgroup/ui_style_helpers/colours'

export const container = css`
  display: flex;
  text-align: left;
  align-items: center;
  margin-top: -6px;
`

export const iconContainer = css`
  svg {
    width: 40px;
    height: 40px;
  }
`

export const textContainer = css`
  font-size: 14px;
  line-height: 1.5;
  color: ${Colour('grey', 400)}};
`
